export const API = {
    CONTRACT: 'contract'
};

export const PARAM = {
    CONTRACT_PUBLIC_ID: 'contractPublicId'
};

export const ROUTE = {
    CONTRACT: 'contract',
    EMAIL: 'email',
    VIEW: 'view'
};
